import {all, call, put, takeEvery} from 'redux-saga/effects';
import {AdminPatientStatusTypesHttpClient, PatientStatusType} from "admins-dashboard/http-clients/index";
import {ORPYXSI_ADMIN_URL} from "../../../../../../appConstants";
import {PATIENT_STATUS_TYPES_INITIALIZE_FAILED, PATIENT_STATUS_TYPES_INITIALIZE_SUCCESSFULLY, PatientStatusTypesActions} from "./patient-status-types-actions";

const API_VERSION = '1';

function* onGetPatientStatusTypes() {
    try {
        const api = new AdminPatientStatusTypesHttpClient(ORPYXSI_ADMIN_URL);
        const data: PatientStatusType[] = yield call([api, api.getPatientStatusTypes], API_VERSION);
        yield put(PATIENT_STATUS_TYPES_INITIALIZE_SUCCESSFULLY(data));
    } catch (e) {
        yield put(PATIENT_STATUS_TYPES_INITIALIZE_FAILED(e));
    }
}

export default function* PatientStatusTypesSagas() {
    yield all([
        takeEvery(PatientStatusTypesActions.INITIALIZE, onGetPatientStatusTypes)
    ]);
}
